import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, Typography } from '@material-ui/core'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { getPrimerTurnoDisponible, seleccionarTurno } from '../../../actions/webAfiliado/afiliadoTurnosAction';
import LoadingBeforeViewData from '../../compartidos/LoadingBeforeViewData';
import AfiliadoTurnosService from '../../../services/AfiliadoTurnosService'
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';
import { startAlerta } from '../../../actions/ui/alertas';
import { useHistory } from 'react-router';
import { capitalize } from '../../../helpers/randoms';
// import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import ScheduleIcon from '@material-ui/icons/Schedule';

const useStyles = makeStyles((theme) => ({
    buttons: {
        marginTop: "2rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-around"
    },
    container: {
        backgroundColor: "#fff", marginTop: "1rem"
    },
    cardPrimary: {
        marginTop: "1rem",
        borderColor: theme.palette.primary.main
    },
    cardError: {
        marginTop: "1rem",
        borderColor: theme.palette.error.main
    },
    itemCard: {
        fontWeight: "bold"
    },
    containerCard: {
        paddingRight: "1rem",
        paddingLeft: "1rem"
    },
    cardIn: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: "outset",
        borderTopWidth: "thick",
        marginRight: "1rem",
        marginLeft: "1rem",
        marginBottom: "1rem",
        borderRadius: 10,
    },
    titleCard: {
        fontWeight: "bold",
        fontSize: 14,
        marginTop: "0.75rem",
        display:"block",
        textAlign: "center"
    },
    containerHourDate: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "0.75rem"
    },
    hourDate: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 5,
        marginLeft: 5
    },
    colorIcons: {
        color: theme.palette.info.main
    }
}));

const SacarTurnoPaso4 = (props) => {
    const { credenciales, seleccionado, idAfiliado, idCentroMedico, idProfesional, idEspecialidad, virtual, primero, errorPrimeroDisponible, datosContacto } = props
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [open, setOpen] = useState(false)

    const [value, setValue] = React.useState(1);

    const handleChange = (event) => {
        setValue(parseInt(event.target.value));
    };
    const handleConfirmar = async () => {
        try {
            dispatch(startSpinner())
            const data = {
                idAgenda: seleccionado.idAgenda,
                idAfiliado: idAfiliado,
                idTipoTurno: seleccionado && seleccionado.idTipoTurno === 3 ? value : seleccionado.idTipoTurno,
                carnet: parseInt(credenciales.find(e => e.idAfiliado === idAfiliado).numero),
                esAfiliado: true
            }
            const result = await AfiliadoTurnosService.confirmarTurno(data)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                setOpen(true)
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error) {
                dispatch(startAlerta(error, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error al confirmar el turno. Intente nuevamente.", "error"))
            }
            console.log("Error en el registro del usuario", error)
        }
    }
    useEffect(() => {
        if (idAfiliado !== "" && primero) {
            dispatch(getPrimerTurnoDisponible(idEspecialidad, idCentroMedico, idProfesional, virtual))
        }
        // eslint-disable-next-line
    }, [])

    if (seleccionado === null && errorPrimeroDisponible === false) {
        return <LoadingBeforeViewData />
    }

    return (
        <Grid container className={classes.container}>
            <Grid item xs={null} sm={null} md={3} />
            <Grid item xs={12} md={6}>
                <Card className={seleccionado === null ? classes.cardError : classes.cardPrimary} variant="outlined">
                    {
                        seleccionado === null
                            ?
                            <CardContent>
                                <Typography color="error" align="justify">No hay un turno disponible con los parámetros especificados. Le solicitamos que, por favor, los modifique y vuelva a intentar.</Typography>
                            </CardContent>
                            :
                            <CardContent>
                                <Typography align="center" color="primary" variant="h6">{`${capitalize(moment(seleccionado.fecha).format("dddd DD"))} de ${moment(seleccionado.fecha).format("MMMM")} | ${seleccionado.hora}`}</Typography>
                                <Divider style={{ marginTop: "1rem", marginBottom: "1rem" }} />

                                <Typography color="primary" className={classes.titleCard}>Nombre completo</Typography>
                                <Typography align="center">{credenciales.find(e => e.idAfiliado === idAfiliado)?.apellidoYNombre}</Typography>

                                <Typography color="primary" className={classes.titleCard}>Especialidad</Typography>
                                <Typography align="center">{seleccionado.especialidad.descripcionEspecialidades}</Typography>

                                <Typography color="primary" className={classes.titleCard}>Centro médico</Typography>
                                <Typography align="center">{`${seleccionado.centroMedico.descripcionCentro}`}</Typography>

                                <Typography color="primary" className={classes.titleCard}>Profesional</Typography>
                                <Typography align="center">{capitalize(`${seleccionado.efectorRed.nombreEfector}`.toLowerCase())}</Typography>
                                
                                <Typography color="primary" className={classes.titleCard}>Modalidad</Typography>
                                {
                                    (primero && seleccionado.idTipoTurno === 3)
                                        ?
                                        <div style={{ textAlign: "center" }}>
                                            <FormControl component="fieldset">
                                                <RadioGroup name="tipo" value={value} onChange={handleChange} style={{ display: 'block' }}>
                                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Presencial" />
                                                    <FormControlLabel value={2} control={<Radio color="primary" />} label="Teleconsulta" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        :
                                        <Typography align="center">{seleccionado.idTipoTurno === 1 ? "Presencial" : "Teleconsulta"}</Typography>
                                }
                                 
                                <Typography align="center" variant="subtitle2" style={{marginTop:"1rem"}}>La información del turno será enviada a los siguientes datos de contacto:</Typography>
                                <Typography align="center" color="primary" variant="subtitle2">{datosContacto.celular}</Typography>
                                <Typography align="center" color="primary" variant="subtitle2">{datosContacto.mail}</Typography>
                            </CardContent>
                    }
                </Card>
            </Grid>
            <Grid item xs={null} sm={null} md={3} />
            <Grid item xs={null} sm={null} md={3} />
            <Grid item xs={12} md={6}>
                <div className={classes.buttons}>
                    <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        style={{textTransform:"none"}}
                        onClick={() => {
                            if (primero) {
                                props.setearVariosValores({
                                    idEspecialidad: null,
                                    idCentroMedico: null,
                                    idProfesional: null,
                                    virtual: false,
                                    primero: false
                                })
                                props.handleChangeStep(1)
                                dispatch(seleccionarTurno(null))
                            } else {
                                props.handleChangeStep(2)
                                dispatch(seleccionarTurno(null))
                            }
                        }}
                    >
                        Anterior
                    </Button>
                    {
                        seleccionado !== null &&
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            style={{textTransform:"none"}}
                            onClick={handleConfirmar}
                        >
                            Confirmar
                        </Button>
                    }
                </div>
            </Grid>
            <Grid item xs={null} sm={null} md={3} />
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ padding: "1rem" }}
            >
                <DialogTitle>
                    <Typography color="primary" align="center" variant="body2" style={{ fontWeight: "bold" }}>¡Muchas Gracias!</Typography>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ textAlign: "center" }}>
                        <Typography color="secondary" align="center">La información del turno fue enviada a los datos de contacto.</Typography>
                        <Typography color="primary" variant="body2" align="center" style={{ marginTop: "1rem", fontSize: 13 }}>A partir del 01 de febrero, implementamos el cobro de coseguros, tanto para las prestaciones ambulatorias que se realicen en prestadores de cartilla como en nuestros Centros Médicos Propios. Informate más haciendo clic <a target='_blank' rel="noreferrer" href='https://www.ospedyc.org/cobro-de-coseguros/'>aquí</a></Typography>
                        <Typography color="primary" variant="body2" align="center" style={{ marginTop: "0.5rem", fontSize: 13 }}>En el caso de no poder asistir, podés cancelar el turno a través de la aplicación.</Typography>
                        <Typography color="primary" variant="body2" align="center" style={{ marginTop: "0.5rem", fontSize: 13 }}>Si tu turno es presencial y tenés síntomas de COVID-19 o sos contacto estrecho, por favor, cancelá el turno y respetá las medidas de prevención.</Typography>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        history.push("/afiliado/turnos")
                        props.handleChangeStep(0)
                        dispatch(seleccionarTurno(null))
                    }} color="primary" autoFocus>Aceptar</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default SacarTurnoPaso4
